import { CAlert } from '@coreui/react';
import { CChart } from '@coreui/react-chartjs';
import Color from 'color';
import * as React from 'react';
import { start } from 'repl';
import { ColumnModel } from '../../models';

interface IProps {
	colDefs: ColumnModel[];

	GraphType: string;
	GraphXPath: string;
	GraphSeries: string;
	GraphSeriesColor: string;
	Rows: any[];
}

interface IState {
	data: any[];
	labels: any[];
	options: any;
	valid: boolean;
}

// Repr�sente un tableau affich� sous forme de graphique)
export class KControlGraph extends React.Component<IProps, IState> {
	public constructor(props: any) {
		super(props);

		this.state = {
			data: [],
			labels: [],
			options: {},
			valid: true,
		}
	}

	screenWidth: number;
	screenHeight: number;

	//#region React Events

	componentDidMount = () => {
		let colors = this.props.GraphSeriesColor.split(";");
		// On ajoute 4 couleurs par d�faut (au cas o� on aurait oubli� d'en mettre dans X3) 
		colors.push("blue");
		colors.push("red");
		colors.push("orange");
		colors.push("green");

		let series = this.props.GraphSeries.split(";");

		let labels: any[] = [];
		for (let i = 0; i < this.props.Rows.length; i++) {
			labels.push(this.props.Rows[i][this.props.GraphXPath]);
		}

		let datasets: any[] = [];
		let options: any = {}

		
		if (";bar;line;pie;".indexOf(";" + this.props.GraphType.toLowerCase() + ";") == -1) {
			this.setState({ valid: false });
			return;
		}

		// En mode camembert, on va effectuer un d�grad� entre startColor & endColor
		let startColor: Color = new Color(colors[0]);
		let endColor: Color = new Color(colors[1]);

		let length = this.props.Rows.length;
		let deltaR: number = (endColor.rgb().array()[0] - startColor.rgb().array()[0]) / length;
		let deltaG: number = (endColor.rgb().array()[1] - startColor.rgb().array()[1]) / length;
		let deltaB: number = (endColor.rgb().array()[2] - startColor.rgb().array()[2]) / length;

		if (this.props.GraphType.toLowerCase() == "pie") {
			let data = [];

			let datasetColors: string[] = [];


			for (let iRow = 0; iRow < length; iRow++) {
				data.push(this.props.Rows[iRow][series[0]]);
				
				datasetColors.push(startColor.hex()); // star

				let newR = startColor.red() + deltaR;
				let newG = startColor.green() + deltaG;
				let newB = startColor.blue() + deltaB;
				startColor = Color.rgb(newR, newG, newB);
			}

			let dataset = {
				backgroundColor: datasetColors,
				data: data,
			};

			datasets.push(dataset);
		}
		else {
			options = {
				scales: {
					yAxes: [{
						ticks: {
							beginAtZero: true
						}
					}]
				}
			};

			for (let serie = 0; serie < series.length; serie++) {

				let data: any[] = [];
				let length = this.props.Rows.length;

				for (let i = 0; i < length; i++) {
					data.push(this.props.Rows[i][series[serie]]);
				}

				let header = "";
				let column = this.props.colDefs.filter(x => x.Key  == series[serie])[0];
				if (column) header = column.Title;

				let dataset = {
					label: header,
					fill: false,
					lineTension: 0.1,

					backgroundColor: colors[serie],
					borderColor: colors[serie],

					pointBorderColor: 'rgba(75,192,192,1)',
					pointBackgroundColor: '#fff',
					pointBorderWidth: 1,
					pointHoverRadius: 5,
					pointHoverBorderWidth: 2,
					pointRadius: 1,
					pointHitRadius: 10,

					data: data,
				};

				datasets.push(dataset);
			}

		}

		this.setState({ data: datasets, labels: labels, options: options });
		this.screenHeight = window.innerHeight;
		this.screenWidth = window.innerWidth;

		window.addEventListener('resize', this.updateDimensions);
	}

	componentWillUnmount = () => {
		window.removeEventListener('resize', this.updateDimensions);
	}

	//#endregion

	//#region Ev�nements locaux

	// Resize de fen�tre, on met � jour les dimensions 
	updateDimensions = () => {
		this.screenHeight = window.innerHeight;
		this.screenWidth = window.innerWidth;
		this.forceUpdate();
	};
	//#endregion 

	//#region Rendus

	render() {
		if (this.state.valid == false) {
			return (
				<div className={`KControlGraph`} >
					<CAlert color="danger" closeButton >Incorrect parameters</CAlert>
				</div>
			)
		}

		if (this.state.data) {
			return (
				<div className={`KControlGraph`} >
					<CChart type={this.props.GraphType} datasets={this.state.data} labels={this.state.labels} options={this.state.options} />
				</div>
			)
		}
		else return ("");
	}

	//#endregion
}